let config = null;

class JsGlobalConfig {
  get apiUrls() {
    return window.__globalConfig.apiUrls;
  }

  getCsrfTokenData() {
    return {
      name: window.__globalConfig.csrfToken.name,
      value: window.__globalConfig.csrfToken.value,
    };
  }

  getCsrfTokenHeader() {
    return {
      'X-CSRF-TOKEN': window.__globalConfig.csrfToken.value,
    }
  }

  getCountry() {
    return window.__globalConfig.country || 'de';
  }

  getBaseUrl() {
    return window.__globalConfig.baseUrl;
  }

  getPasswordSpecialChars() {
    return window.__globalConfig.passwordValidation.specialChars;
  }

  getPasswordMin() {
    return window.__globalConfig.passwordValidation.min;
  }

  getPasswordMax() {
    return window.__globalConfig.passwordValidation.max;
  }

  getGtm() {
    return window.__globalConfig.gtm;
  }

}

function jsGlobalConfig() {
  if (config) {
    return config;
  } else {
    config = new JsGlobalConfig();
    return config;
  }
}

export default jsGlobalConfig;

